
import { useDispatch } from 'react-redux';
import { logout } from '../redux/features/auth.features';
import { jwtDecode } from 'jwt-decode';

export const useCheckTokenExpiration = () => {
  const dispatch = useDispatch();

  const checkTokenExpiration = () => {
    const token = localStorage.getItem('token');

    if (!token) {
      // dispatch(logout());

      console.log("token not found")
      return false;
    }

    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      if (decoded.exp < currentTime) {
        // dispatch(logout());
        console.log('token expired')
        return false;
      }

      // console.log('token valid')
      return true;
    } catch (error) {
      // dispatch(logout());
      console.log("token decode failed")
      return false;
    }
  };

  return checkTokenExpiration;
};